<section
  class="mbs-wizard_form"
  [formGroup]="stepForm">
  <header
    *ngIf="!isConsistencyCheck"
    class="mbs-wizard_form-header mb-4">
    <div class="mbs-wizard_form-description">
      {{ 'wizards:advanced_schedule_subtitle' | i18next: { type: subtitleByType } }}
    </div>
  </header>

  <div class="mbs-wizard_form-content pb-5">
    <mbs-form-group [class.mb-5]="!isBackupPlan || (isUnix && !isNetBuild)">
      <mbs-accordion
        [closeOthers]="false"
        [size]="'sm'"
        (panelChange)="toggleChangePanel($event)">
        <mbs-accordion-panel
          *ngFor="let name of panelNames"
          [disabled]="
            (name !== 'forceFull' && !stepForm.get('forceFull').value.Enabled) ||
            stepForm.get(name).disabled ||
            !stepForm.get(name).value.Enabled
          "
          [id]="name"
          [title]="''">
          <ng-container panelTitle>
            <span class="d-block">
              {{ getPanelTitle(name) }}
            </span>
            <span
              *ngIf="panelsInfo[name].infoString"
              class="text-xs fw-normal d-block"
              [attr.data-e2e]="elementsSelector[name].infoString">
              {{ panelsInfo[name].infoString }}
            </span>
          </ng-container>
          <div
            class="d-flex justify-content-end pr-3"
            panelAppendHeader
            [formGroupName]="name">
            <mbs-switcher
              class="pt-1"
              formControlName="Enabled"
              [id]="name + '-switcher'"
              (change)="switcherChangeHandler($event, name)"></mbs-switcher>
          </div>

          <mbs-form-group
            class="mb-0"
            [formGroup]="scheduleSettingsForm">
            <div
              class="row"
              [formGroupName]="name">
              <div class="col-6 text-base">
                <mbs-form-group class="mb-0">
                  <h6 class="mbs-form-group_title">
                    {{ 'wizards:frequency_label' | i18next }}
                  </h6>

                  <mbs-form-group>
                    <mbs-select
                      formControlName="RecurringPeriod"
                      [clearable]="false"
                      [id]="name + '-RecurringPeriod'"
                      [items]="RecurringPeriodItems"
                      [searchable]="false"
                      (change)="recurringPeriodChangeHandler($event, name)"></mbs-select>
                  </mbs-form-group>

                  <mbs-form-group
                    *ngIf="scheduleSettingsForm.get(name).value.RecurringPeriod === 'Monthly'"
                    [attr.data-e2e]="elementsSelector[name].monthly">
                    <div class="form-row">
                      <div class="col-6">
                        <mbs-select
                          formControlName="Occurrence"
                          [appendTo]="'.mbs-wizard-steps_container'"
                          [bindLabel]="'label'"
                          [bindValue]="'value'"
                          [boldLabel]="false"
                          [clearable]="false"
                          [hideSelected]="true"
                          [id]="name + '-occurrence-select'"
                          [items]="WeekNumberEnumArray"
                          [label]="'wizards:occurrence_label' | i18next"
                          [searchable]="false"></mbs-select>
                      </div>
                      <div class="col-6">
                        <mbs-number
                          *ngIf="scheduleSettingsForm.get(name).value.Occurrence === -1"
                          formControlName="DayOfMonthCount"
                          [attr.data-e2e]="elementsSelector[name].dayOfMonthCount"
                          [id]="name + 'DayOfMonthCount'"
                          [label]="'wizards:day_label' | i18next"
                          [max]="31"
                          [min]="1"></mbs-number>
                        <mbs-select
                          *ngIf="scheduleSettingsForm.get(name).value.Occurrence !== -1"
                          formControlName="DayOfWeek"
                          [appendTo]="'.mbs-wizard-steps_container'"
                          [attr.data-e2e]="elementsSelector[name].dayOfWeek"
                          [bindLabel]="'label'"
                          [bindValue]="'value'"
                          [boldLabel]="false"
                          [clearable]="false"
                          [hideSelected]="true"
                          [id]="name + '-DayOfWeek-select'"
                          [items]="DaysOfWeekEnumArray"
                          [label]="'wizards:day_label' | i18next"
                          [searchable]="false"></mbs-select>
                      </div>
                    </div>
                  </mbs-form-group>

                  <mbs-form-group
                    *ngIf="!isUnix || isNetBuild || scheduleSettingsForm.get(name).value.RecurringPeriod === 'Monthly'"
                    [attr.data-e2e]="elementsSelector[name].notUnixOrMonthly"
                    [class.mb-0]="scheduleSettingsForm.get(name).value.RecurringPeriod !== 'Weekly'">
                    <div class="form-row">
                      <div class="col-6">
                        <mbs-input-label [label]="'wizards:repeat_every_label' | i18next"> </mbs-input-label>
                        <div class="form-row align-items-center">
                          <div class="col-6">
                            <mbs-number
                              formControlName="RepeatEveryCount"
                              [id]="name + 'repeat-every-count'"
                              [max]="
                                scheduleSettingsForm.get(name).value.RecurringPeriod === 'Daily'
                                  ? 31
                                  : scheduleSettingsForm.get(name).value.RecurringPeriod === 'Weekly'
                                    ? 52
                                    : scheduleSettingsForm.get(name).value.RecurringPeriod === 'Monthly'
                                      ? 12
                                      : 99
                              "
                              [min]="1"></mbs-number>
                          </div>
                          <span class="col-auto">
                            <label
                              class="mbs-form_label mb-0"
                              [for]="name + 'repeat-every-count'">
                              {{ getCounterText(name) }}
                            </label>
                          </span>
                        </div>
                      </div>
                      <div class="col-6">
                        <mbs-datepicker
                          formControlName="StartFromDate"
                          [boldLabel]="false"
                          [label]="'wizards:start_from_label' | i18next"
                          [needSetCurrent]="true"></mbs-datepicker>
                      </div>
                    </div>
                  </mbs-form-group>

                  <mbs-form-group
                    *ngIf="scheduleSettingsForm.get(name).value.RecurringPeriod === 'Weekly'"
                    class="mb-0"
                    [attr.data-e2e]="elementsSelector[name].weekly">
                    <div
                      class="d-flex align-items-center"
                      formArrayName="WeeklyDayOfWeek">
                      <mbs-checkbox
                        *ngFor="let day of DaysOfWeekEnumArray; let i = index; let len = count"
                        class="mt-0"
                        [centerCheckbox]="true"
                        [class.mr-3]="i !== len - 1"
                        [formControlName]="i.toString()"
                        [label]="getDayLabel(day.label)"
                        [labelPosition]="'top'"></mbs-checkbox>
                    </div>
                  </mbs-form-group>
                </mbs-form-group>
              </div>

              <div class="col-6 text-base">
                <h6 class="mbs-form-group_title">
                  {{ 'wizards:daily_frequency_label' | i18next }}
                </h6>

                <mbs-form-group>
                  <mbs-radio
                    formControlName="DailyFreqPeriodOption"
                    value="OccursAt"
                    [descriptionOutside]="false"
                    [id]="name + '-occurs-at-radio-1'"
                    [label]="'wizards:occurs_at_label' | i18next"
                    [name]="name + '-dailyFreqPeriodOption'"
                    (change)="dailyFreqPeriodChangeHandler($event, name)">
                    <ng-template radioDescription>
                      <div class="form-row">
                        <div class="col-7">
                          <mbs-timepicker
                            formControlName="OccursAtTime"
                            [meridian]="true"
                            [needChangeInvalid]="true"></mbs-timepicker>
                        </div>
                      </div>
                    </ng-template>
                  </mbs-radio>
                </mbs-form-group>

                <mbs-form-group>
                  <mbs-radio
                    formControlName="DailyFreqPeriodOption"
                    value="OccursEvery"
                    [descriptionOutside]="false"
                    [id]="name + '-occurs-at-radio-2'"
                    [label]="'wizards:occurs_every_label' | i18next"
                    [name]="name + '-dailyFreqPeriodOption'"
                    (change)="dailyFreqPeriodChangeHandler($event, name)">
                    <ng-template radioDescription>
                      <mbs-form-group>
                        <div class="form-row">
                          <div class="col-4">
                            <mbs-number
                              formControlName="OccursEveryCount"
                              [max]="scheduleSettingsForm.get(name).value.OccursEveryPeriod === 'hours' ? maxHours : maxMinutes"
                              [min]="1"></mbs-number>
                          </div>
                          <div class="col-6">
                            <mbs-select
                              formControlName="OccursEveryPeriod"
                              [bindLabel]="'label'"
                              [bindValue]="'value'"
                              [clearable]="false"
                              [items]="hoursOrMinutesItems"
                              [searchable]="false"
                              (change)="occursEveryPeriodChangeHandler($event, name)"></mbs-select>
                          </div>
                        </div>
                      </mbs-form-group>

                      <mbs-form-group class="mb-0">
                        <div class="form-row align-items-center">
                          <div class="col-6">
                            <mbs-timepicker
                              formControlName="OccursEveryFromTime"
                              [boldLabel]="false"
                              [id]="name + 'occurs-every-from-time'"
                              [label]="'wizards:big_from_label' | i18next"
                              [meridian]="true"
                              [needChangeInvalid]="true"></mbs-timepicker>
                          </div>
                          <div class="col-6">
                            <mbs-timepicker
                              formControlName="OccursEveryToTime"
                              [boldLabel]="false"
                              [id]="name + 'occurs-every-to-time'"
                              [label]="'wizards:big_to_label' | i18next"
                              [meridian]="true"
                              [needChangeInvalid]="true"></mbs-timepicker>
                          </div>
                        </div>
                      </mbs-form-group>
                    </ng-template>
                  </mbs-radio>
                </mbs-form-group>
              </div>
            </div>
          </mbs-form-group>
        </mbs-accordion-panel>
      </mbs-accordion>
    </mbs-form-group>

    <mbs-form-group
      *ngIf="isBackupPlan && (!isUnix || isNetBuild)"
      class="mb-0"
      [attr.data-e2e]="elementsSelector.other.backupNotUnix">
      <mbs-checkbox
        formControlName="ForceFullApplyDiffSizeCondition"
        [descriptionOutside]="false"
        [id]="'force-full-apply-diff-size-condition-checkbox'"
        [label]="'wizards:run_incremental_label' | i18next">
        <ng-template checkboxDescription>
          <div class="form-row align-items-center">
            <div class="col-2">
              <mbs-number
                formControlName="ForceFullDiffSizeCondition"
                [id]="'force-full-diff-size-condition'"
                [min]="1"></mbs-number>
            </div>
            <div class="col-auto">
              <label
                class="mbs-form_label mb-0"
                for="force-full-diff-size-condition"
                [class.-disabled]="!stepForm.get('ForceFullApplyDiffSizeCondition').value">
                {{ 'wizards:incremental_size_label' | i18next }}
              </label>
            </div>
          </div>
        </ng-template>
      </mbs-checkbox>
    </mbs-form-group>

    <mbs-alert
      *ngIf="recurringScheduleError"
      class="mb-0"
      [icon]="true"
      [type]="mbsPopupType.danger">
      {{ recurringScheduleError }}
    </mbs-alert>
  </div>
</section>
